import React, { createContext, useContext, useMemo } from 'react'
import { useGetRestaurant } from '../api/restaurant/useGetRestaurant'
import { addEventProperties } from '@toasttab/do-secundo-analytics'

type RestaurantContextValue = {
  shortUrl: string
  restaurantGuid: string
}

const RestaurantContext = createContext<RestaurantContextValue | null>(null)

export const useRestaurantContext = () => {
  const context = useContext(RestaurantContext)
  if (!context) {
    throw new Error('Calling useRestaurantContext outside of a provider')
  }
  return context
}

export const RestaurantProvider = ({
  children,
  /**
   * FIXME:
   * If we look at usage in App.tsx, we see that we never inject a shortUrl;
   * it's always going to be undefined.
   * We should probably get this somewhere, as fed through from capman-guest-node
   *
   * See semi-related issue: https://toasttab.atlassian.net/browse/TTCORE-3468
   */
  shortUrl,
  restaurantGuid
}: {
  children: React.ReactNode
  shortUrl?: string
  restaurantGuid: string
}) => {
  const { data: restaurant } = useGetRestaurant(restaurantGuid, {
    slotTime: null
  })
  // const { data } = useFetchRestaurantV2(restaurantGuid)
  // Also, do a side-effect to update our analytics
  React.useEffect(() => {
    addEventProperties({
      restaurantGuid
    })
  })

  const contextValue = useMemo(() => {
    const shortUrlValue = shortUrl || restaurant?.toastRestaurantShortName || ''
    // TODO: https://toasttab.atlassian.net/browse/TTCORE-3468
    // shortUrl || data?.shortUrl || restaurant?.toastRestaurantShortName || ''
    return {
      shortUrl: shortUrlValue,
      restaurantGuid
    }
  }, [restaurant?.toastRestaurantShortName, restaurantGuid, shortUrl])

  return (
    <RestaurantContext.Provider value={contextValue}>
      {children}
    </RestaurantContext.Provider>
  )
}
